import Icon from "./IconDialogClose.svg?react";
import styled from "@emotion/styled";

export const IconDialogClose = styled(Icon)`
  width: 1.5rem;
  height: 1.5rem;
  color: var(--color-charcoal, #212121);
`;
